import { Component, computed, inject, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LoaderService } from './loader.service';

import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
    selector: 'app-loader',
    imports: [TranslateModule, MatProgressBarModule],
    providers: [],
    templateUrl: './loader.component.html',
    styleUrl: './loader.component.scss'
})
export class LoaderComponent {
  public loaderService = inject(LoaderService);

  // Stato globale: almeno una sessione è attiva
  isLoading = this.loaderService.isLoading;

  // Messaggio della sessione più recente
  message = this.loaderService.currentMessage;

  // Progresso della sessione più recente
  progress = this.loaderService.currentProgress;

  constructor() {
  }
}
